export default "__VITE_ASSET__03e28b65__"